import axios from "axios";
import React, { useState } from "react";
import Results from "./Results.js";
import Photos from "./Photos.js";

import "./Dictionary.css";

export default function Dictionary(props) {
  let [keyword, setKeyword] = useState(props.defaultKeyword);
  let [results, setResults] = useState(null);
  let [loaded, setLoaded] = useState(false);
  let [photos, setPhotos] = useState(null);

  function handleResponse(response) {
    //console.log(response.data[0].meanings[0].definitions[0].definition);
    setResults(response.data[0]);
  }

  function handleDictionaryResponse(response) {
    // console.log(response);
    setPhotos(response.data.photos);
  }

  function search() {
    let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${keyword}`;
    axios.get(apiUrl).then(handleResponse);

    let pexelsApiKey =
      "563492ad6f917000010000018c84844aa1f7466c902d6fd48ef415f7";
    let pexelsApiUrl = `https://api.pexels.com/v1/search/?page=2&per_page=6&query=${keyword}`;
    let header = { Authorization: `Bearer ${pexelsApiKey}` };
    axios.get(pexelsApiUrl, { headers: header }).then(handleDictionaryResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleKeyword(event) {
    setKeyword(event.target.value);
  }

  function load() {
    setLoaded(true);
    search();
  }

  if (loaded) {
    return (
      <div className="Dictionary">
        <section>
          <h3>What word are you looking for?</h3>
          <form onSubmit={handleSubmit}>
            <input
              type="search"
              className="Search"
              placeholder=""
              autoFocus={true}
              onChange={handleKeyword}
              defaultValue={props.defaultKeyword}
            ></input>
          </form>
          <div className="hint">
            Suggested words: sunset, wine, plant, dictionary
          </div>
        </section>
        <Results result={results} />
        <Photos photo={photos} />
      </div>
    );
  } else {
    load();
    return "Loading...";
  }
}
